export enum CrudViewModes {
  List,
  View,
  Edit,
  New,
}
